function timeEnabledLayers(state) {
    const timeEnabledLayers = state.layers.filter((val) => {
        let dates = Object.values(val.required_parameters).filter((value) => {
            if (value.type === 'timestamp') {
                return true;
            }
        });
        if (dates.length > 0) {
            return true;
        }
    });
    return timeEnabledLayers;
}
export const getters = {
    activeBasemap: (state) => {
        return state.basemaps.find((layer) => layer.getVisible());
    },
    activeMenuItem(state) {
        return state.sidetray.title;
    },
    activeLayers(state) {
        return state.layers;
    },
    timeEnabledLayers(state) {
        return timeEnabledLayers(state);
    },
    canBeTimeEnabled(state) {
        let layers = timeEnabledLayers(state);
        return layers.length > 0;
    },
    hasActiveMapInstance(state) {
        return state.ol.map !== undefined;
    },
};
